import React, { FC } from 'react'
import valueProps from './data'
import styles from './ValueProps.module.scss'
import useQA from 'hooks/useQA'
import SALink from 'components/SALink'

const ValueProps: FC = () => {
  const { testId } = useQA()

  return (
    <div className={styles.valuePropsContainer} {...testId('value-props-container')}>
      <div className={styles.valuePropsGrid} {...testId('value-props-grid')}>
        <div className={styles.titleSection}>
          <h4 className={styles.title}>Why Shop On Saatchi Art?</h4>
          <p className={styles.subText}>
            Saatchi Art is the best place to buy artwork online with confidence. Discover <SALink href="https://www.saatchiart.com/paintings">original paintings</SALink>,
            {' '}<SALink href="https://www.saatchiart.com/photography/fine-art">fine art photography</SALink>, <SALink href="https://www.saatchiart.com/sculpture">sculpture</SALink>, and more from the world's largest selection
            of original art.
          </p>
        </div>
        <div className={styles.list}>
          {valueProps.map((valueProp, key) => (
            <div key={key} className={styles.item} {...testId('value-props-item')}>
              <div className={styles.icon}>{valueProp.icon}</div>
              <div className={styles.itemText}>
                <h6 className={styles.title}>{valueProp.title}</h6>
                <p className={styles.description}>{valueProp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ValueProps
